/** @format */

// plans.html hides #body until <html> gains `react-ready`. This is the other
// half of that mechanism; see the comment in the template.
export function markReactReady() {
  // rAF, not the effect body: PlansPage's ?recommended= mount effect queues a
  // state update that commits *after* this effect runs. The frame callback
  // waits for that second render, so the page is revealed already settled.
  requestAnimationFrame(() => {
    document.documentElement.classList.add('react-ready')
  })
}
